import React, { useContext } from 'react';
import styles from './style';
import { Box, Typography, IconButton } from '@material-ui/core';
import Delete from '@material-ui/icons/DeleteForeverOutlined';
import { DestinationsContext } from '../../../Providers/Destinations';

const DestinationInfo = () => {
  const classes = styles();
  const { destinations, removeDestination } = useContext(DestinationsContext);
  
  const removeDestinationFromProvider = (id: string) => {
    removeDestination(id);
  };

  return (
    <Box>
      {destinations.length > 0 && (
        <Box className={classes.container}>
          <Box className={classes.bordered}>
            <Typography>{destinations[0].name}</Typography>
            <Typography>{destinations[0].phone}</Typography>
            <Typography>{destinations[0].address}</Typography>
          </Box>

          <IconButton
            size="small"
            onClick={() => removeDestinationFromProvider(destinations[0].id)}>
            <Delete />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default DestinationInfo;
